module.exports = __webpack_public_path__ + "images/logo@2x_c4f4e986d5ef13ff768300e9281f3154.png";